import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const STORAGE_KEY = 'invicta_selected_branch';

// Merkt sich die gewählte Branche (Login/Registrierung → Onboarding).
export const storeSelectedBranch = (branch) => {
  try {
    if (branch?.key) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        key: branch.key, group: branch.group || null, name: branch.name || null,
        practice_type: branch.practice_type || null,
      }));
    }
  } catch (e) { /* ignore */ }
};

export const getSelectedBranch = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) { return null; }
};

export const clearSelectedBranch = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
};

/**
 * Liest ?branch=key aus der URL (oder localStorage) und lädt die Branchen-Daten.
 * Liefert { branch, loading }. branch === null → Standard-Branding (InvictaFit).
 */
export function useBranchTheme() {
  const [params] = useSearchParams();
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const urlKey = (params.get('branch') || '').trim().toLowerCase();
    const stored = getSelectedBranch();
    const key = urlKey || stored?.key || '';
    if (!key) { setLoading(false); return; }

    let active = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/public/branches/${key}`);
        if (active && data?.exists) {
          setBranch(data);
          storeSelectedBranch(data);
        }
      } catch (e) {
        /* Fallback auf Standard-Branding */
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return { branch, loading };
}
